import { Amplify } from 'aws-amplify';

import configureStorage, { storageConfig } from '../api/configureStorage';
import aws from './aws';

const stage = window.REACT_APP_NODE_ENV;
configureStorage(stage);

export default function amplify() {
    Amplify.configure({
        Auth: {
            mandatorySignIn: true,
            region: aws.cognito.REGION,
            userPoolId: aws.cognito.USER_POOL_ID,
            identityPoolId: aws.cognito.IDENTITY_POOL_ID,
            userPoolWebClientId: aws.cognito.APP_CLIENT_ID,
            cookieStorage: {
                sameSite: 'strict',
                secure: true,
                path: '/',
                expires: 5,
            },
        },
        Storage: {
            AWSS3: {
                bucket: storageConfig.STORAGE_DOWNLOAD, // download bucket (upload bucket needs to explicitly specified when uploading)
                region: 'eu-west-1',
            },
        },
        API: {
            endpoints: aws.apiGatewayEndpoints,
        },
    });
    Amplify.Logger.LOG_LEVEL = stage === 'production' ? 'ERROR' : 'INFO';
}
